import { gql } from '@apollo/client'

const GET_FUNDER_ORG_CONFIG_QUERY = gql`
  query getFunderOrgConfig($email: String!) {
    funderOrgConfig(email: $email) {
      sponsoredNonprofits {
        nonprofitOrgId
        name
      }
      orgName
      orgId
      user {
        ... on FunderUserConfig {
          id
          firstName
          lastName
          email
          phone
          role
          funderOrgRole
        }
      }
    }
  }
`

export default GET_FUNDER_ORG_CONFIG_QUERY
